/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import './styles.css';

import ReactLoading from "react-loading";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from "reactstrap";

import axios from 'axios';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import { GetFetch, PostFetch } from '../../../../../../services/apiBase';

export function AnticipateCprModal({ open, onClose, cprNumber, username, personne_id, redirect, coupons }) {
  
  const [loading, setLoading] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [changeValues, setChangeValues] = useState(false);
  const [amount_cpr, setAmount_cpr] = useState(0);
  const [currentAmount, setCurrentAmount] = useState();
  const [anticipateDate, setAnticipateDate] = useState(new Date());
  const [currentCupon, setCurrentCupon] = useState(null);
  const [data, setData] = useState();

  const [dateError, setDateError] = useState(false);
  const error = changeValues && ((amount_cpr < currentAmount.amount_cpr) || (amount_cpr < currentAmount.cpr_yield_current_date))

  const handleOnCloseModal = () => {
    setChangeValues(false)
    setAnticipateDate(new Date())
    onClose()
  }

  const loadInitialData = async () => {
    setLoading(true)
    setChangeValues(false)
    setAnticipateDate(new Date())
    // FIX ME FORCE STATE SYNC FOR METHOD
    setTimeout(() => {getCprValues();}, 200);
  }
    
  const getCprValues = async () => {
    setLoading(true)
    try {

      // const {data} = await api
      // .get(`/financial/listCprPaginated?page=${currentPage}&limit=${limit}&status=${filterStatus}&name=${query}${filterValues}`);
      
      const { data } = await GetFetch(`/financial/showCpr?cpr_number=${cprNumber}&personne_id=${personne_id}&current_date=${moment.utc(anticipateDate).format('MM/DD/YYYY')}`);
      setCurrentAmount(data)
      setAmount_cpr(data.cpr_yield_current_date)
      await findCurrentCupon()
    } catch (error) {
      console.log('ERROR:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async () => {
    try {
      const data = {
        cpr_number: cprNumber,
        username: username,
        amount_cpr: changeValues ? amount_cpr : currentAmount.cpr_yield_current_date,
        anticipateDate: changeValues ? moment.utc(new Date(anticipateDate)).format('YYYY-MM-DD') : moment.utc(new Date()).format('YYYY-MM-DD')
      };

      await PostFetch(`/financial/anticipateCpr`, data);

      let message = `CPR nº ${cprNumber} antecipada com sucesso`
      enqueueSnackbar(message, { variant: 'success' });

      redirect();
    } catch (error) {
      enqueueSnackbar('Não foi possível antecipar a CPR', { variant: 'error' });
      enqueueSnackbar(error.response.data.error, { variant: 'error' });
    }
  }

  function formatDate(date) {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return date.toLocaleDateString('pt-BR', options);
  }

  const isDateInRange = (coupon, date) => {
    const currentDate = date ? new Date(date) : new Date();
    const inRangeCupon = currentDate >= new Date(coupon.date_start) && currentDate <= new Date(coupon.date_end);
    return inRangeCupon;
  }


  const findCurrentCupon = async () => {
    if (data && data.cprs_yield?.length > 0) {
      for (let i = 0; i < data.cprs_yield.length; i++) {
        const element = data.cprs_yield[i];
        if (isDateInRange(element)) {
          setCurrentCupon(element)
        }
      }
    }
  }

  const AnticipateAmountCalc = async () => {
    getCprValues();
  } 

  useEffect(() => {
    getCprValues();
  }, [cprNumber, data])

  useEffect(() => {
    setData(coupons)
  }, [coupons])

  useEffect(() => {
    if (currentCupon !== null) {
      setDateError(changeValues && !isDateInRange(currentCupon, anticipateDate))
    }
  }, [changeValues, anticipateDate])

  return (
    <Modal
      style={{marginTop: '100px', zIndex: 5}}
      onOpened={() => { loadInitialData() }}
      isOpen={open} toggle={handleOnCloseModal} >
      <ModalHeader toggle={handleOnCloseModal}>Confirme a antecipação da CPR</ModalHeader>

      <ModalBody style={{ backgroundColor: "#fff" }} >
        {!loading ?
          <>
            <span>Valor investido:</span>
            <h4>{currentAmount && Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(currentAmount.amount_cpr)}</h4>
          
            <div>
              {changeValues ?
                <div className='dateWrapper' id='dateWrapper'>
                  <span>Selecione a data para antecipação (Opcional)</span>
                  <Input 
                    value={anticipateDate}
                    id={`anticipateDate`}
                    type='date'
                    onChange={e => setAnticipateDate(e.target.value)}
                  />
                </div>
                :
                <div className='dateWrapper' id='dateWrapper'>
                  <span>Data para antecipação:</span>
                  <h4>{moment.utc(new Date()).format('DD/MM/YYYY')}</h4>
                </div>
              }
            </div>
            
            {dateError && 
              <span className='error' id='error' >A data de antecipação não pode ser posterior ao cupom vigente. {`\n\n`}</span>
            }

            {changeValues && 
              <div id='buttonCalcWrapper' className='buttonCalcWrapper'>
                <Button color="warning" onClick={() => AnticipateAmountCalc()}>Calcular</Button>
              </div>
            }
          
            {changeValues ?
              <>
                <span>Valor final:</span>
                <Input
                  value={amount_cpr}
                  id="amount_cpr"
                  type='number'
                  onChange={e => setAmount_cpr(e.target.value)}
                />
              </>
              :
              <>
                <span>Valor total atualizado:</span>
                <h4>{currentAmount && Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(currentAmount.cpr_yield_current_date)}</h4>
              </>
            }
            {error && 
              <span className='error' id='error' >O valor final deve ser maior que o investimento inicial.</span>
            }
            <Button color="warning" id='changeButton' className='changeButton' onClick={() => {setChangeValues(!changeValues) }} >{ changeValues ? `Liquidar hoje: ${formatDate(new Date())}`  : 'Alterar valores' }</Button>
          </>
          :
          <div className="w-100 d-flex justify-content-center align-items-center">
            <ReactLoading type='bubbles' color="#feb049" />
          </div>
        }

        <div className="modal-footer">
          {loadingForm ? (
            <div className="w-100 d-flex justify-content-center align-items-center">
              <ReactLoading type='bubbles' color="#feb049" />
            </div>
          ) : (
            <>
              <Button color="danger" onClick={handleOnCloseModal}>Fechar</Button>
              <Button color="success" type="submit" disabled={error || dateError} onClick={() => {handleSubmit()}}>Antecipar</Button>
            </>
          )}
        </div>

      </ModalBody>
    </Modal>
  )
}
